<template>
  <div class="flex flex-col min-h-screen items-center">
    <div class="flex justify-between items-center w-full max-w-[1280px]">
      <div class="ml-4 sm:ml-0">
        <LogoIcon />
      </div>
      <div class="h-12 mt-5 mb-5 mr-4 sm:mr-8">
        <LanguageSwitch />
      </div>
    </div>
    <div class="max-w-[460px] w-full text-center flex-grow px-4">
      <h2 class="mt-5 mt-10 mb-6 text-center">
        {{ $t('messages.wait_activation.title') }}
      </h2>
      <div class="bg-white rounded-lg">
        <div class="flex mb-4 text-left">
          <img
            class="ml-6 mt-6 h-12 w-12"
            src="@/assets/svg/icon_48px_send.svg"
            alt=""
          >
          <div class="ml-4 mt-6 mr-6">
            <span class="b1 text-zyxel-gray-800 font-bold">{{ $t('messages.common.hint_send_email_to')
            }}</span><br>
            <span class="b1 text-zyxel-gray-800 font-bold break-all whitespace-normal">{{ toEmail }}</span>
          </div>
        </div>
        <p class="b1 block text-left text-zyxel-gray-800 ml-6 mr-6 mb-8 pb-6">
          {{
            $t('messages.wait_activation.description') }}
        </p>
      </div>
      <div class="mt-4 mb-6">
        <span
          class="mr-4 b1 text-zyxel-gray-800"
          style="color: #575757"
        >{{
          $t('messages.common.hint_not_receive_yet') }}</span><router-link
          class="b1 text-zyxel-green-700"
          :to="{ name: 'SendActivation' }"
        >
          {{ $t('messages.common.link_send_again') }}
        </router-link>
      </div>

      <div class="mb-6">
        <span
          class="mr-4 b1"
          style="color: #575757"
        >{{ $t('messages.common.hint_sign_another') }}</span>
        <router-link
          class="b1 text-zyxel-green-700"
          :to="{ name: 'SignIn' }"
        >
          {{ $t('messages.common.link_sign_in')
          }}
        </router-link>
      </div>
    </div>
    <ZyxelFooter />
  </div>
</template>
<script>
import { useRoute } from 'vue-router';
import LogoIcon from '@/components/LogoIcon.vue';
import LanguageSwitch from "@/components/LanguageSwitch.vue";
import ZyxelFooter from "@/components/ZyxelFooter.vue";

export default {
    name: 'WaitActivationPage',
    components: {
        LogoIcon,
        LanguageSwitch,
        ZyxelFooter,
    },
    setup() {
        const route = useRoute();
        const toEmail = route.query.to_email;

        return { toEmail };
    },
}
</script>